export default {
  //授课班级 教学轨迹
  SKteachingTrack: '',
  //授课班级 到课率
  SKcourseRatio: '',
  //授课班级 作业率
  SKhomeworkRatio: '',
  //授课班级 任务率
  SKtaskRatio: '',
  //授课班级 测试率
  SKtestRatio: '',
  //授课班级 小组排名
  SKgroupList: '',
  //授课班级 学生进步排名
  SKstuImproveList: '',
  //授课班级 学生活跃排名
  SKstuLivelyList: '',
  //授课班级 学生素质排名
  SKstuQualityList: '',
  //授课班级 学生成绩排名
  SKstuAchievementList: '',
  //授课班级 活动参与率
  SKactiveRatio: '',
}
